function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 260,
  cy: 260,
  r: 220,
  fill: "#eaedf2",
  transform: "matrix(.1091 0 0 .1091 -4.364 -4.364)"
});

var SvgSolidCircle = function SvgSolidCircle(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2
  }, props), _ref);
};

export default SvgSolidCircle;